import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import {Field} from 'simple-react-form'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import DateText from 'orionsoft-parts/lib/components/fields/DateText'
import Number from 'orionsoft-parts/lib/components/fields/numeral/Number'
import Select from 'orionsoft-parts/lib/components/fields/Select'
import Checkbox from 'App/components/fields/Checkbox'
import PhoneNumber from 'App/components/fields/PhoneNumber'
import Email from 'App/components/fields/Email'
import Rut from 'App/components/fields/Rut'
import Title from './Title'
import {titles} from './titles'
import {city} from './comunas'
import uniqWith from 'lodash/uniqWith'
import isEqual from 'lodash/isEqual'

function validation(validation, type) {
  if (!validation && type === 'text') return Text
  if (type === 'checkbox') return Checkbox
  if (validation === 'rut') return Rut
  if (validation === 'email') return Email
  if (validation === 'telefono') return PhoneNumber
  if (validation === 'number') return Number
  if (validation === 'date') return DateText
  if (validation === 'select') return Select
  return Text
}

function formStructure(fields) {
  const sections = []
  fields.forEach(field => {
    if (titles[field.name]) sections.push({title: titles[field.name], fields: []})
    sections[sections.length - 1].fields.push(field)
  })
  return sections
}

function comuna(field) {
  if (field.name === 'Comuna Cliente' || field.name === 'Comuna Usuario') {
    const options = city.map(comuna => {
      return {label: comuna.name, value: comuna.name}
    })
    return options
  }
  if (field.name === 'Ciudad Cliente' || field.name === 'Ciudad Usuario') {
    const data = city.map(comuna => {
      return {label: comuna.provincia, value: comuna.provincia}
    })
    const options = uniqWith(data, isEqual)
    return options
  }
  return null
}

function renderFields(fields, className) {
  return (
    <div className="row">
      {fields.map((field, index) => {
        return (
          <div key={index} className={className}>
            {field.name && (
              <div className="label" style={{paddingTop: 10}}>
                {field.name}
              </div>
            )}
            <Field
              fieldName={field.name}
              type={validation(field.validation, field.type)}
              maxLength={field.maxLength ? field.maxLength : null}
              options={comuna(field)}
            />
          </div>
        )
      })}
    </div>
  )
}

function withTitle(fields, className) {
  const sections = formStructure(fields) || []
  return (
    <div className={styles.container}>
      {sections.map((section, index) => {
        return (
          <div key={index}>
            <div className="row">
              <Title title={section.title} />
            </div>
            <div className={styles.fields}>{renderFields(section.fields, className)}</div>
          </div>
        )
      })}
    </div>
  )
}

function FormFields({fields, className, hasTitle}) {
  if (!hasTitle) return renderFields(fields, className)
  return withTitle(fields, className)
}

FormFields.propTypes = {
  fields: PropTypes.array.isRequired,
  className: PropTypes.string
}

export default FormFields



// WEBPACK FOOTER //
// ./src/App/components/FormFields/index.js